/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UserDelete$Params {
  userId: number;
  practiceId: string | null;
}

export function userDelete(http: HttpClient, rootUrl: string, params: UserDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, userDelete.PATH, 'delete');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.path('practiceId', params.practiceId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

userDelete.PATH = '/api/practices/{practiceId}/users/{userId}';
